// extracted by mini-css-extract-plugin
export default {"image":"U4-z","loaded":"V4-z","placeholder":"W4-z"};